// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5861c462","389":"6f703bbc","453":"5d969051","455":"1f5b03d0"}[chunkId] + ".chunk.js";
};